package uz.ferro.erp.feature.faq.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.text.model.DocContent

@Serializable
data class FaqItem(
    val key: String?,
    val title: String,
    val content: DocContent
)